import api from './client';

/**
 * Compare two bike workouts.
 *
 * @param {string} baseSessionId — AnalysisSession ID for workout A
 * @param {{ type: 'upload', file: File } | { type: 'myfile', fileId: number } | { type: 'community', sharedId: number }} source
 */
export const compareBikeWorkout = async (baseSessionId, source) => {
  const form = new FormData();
  form.append('base_session_id', baseSessionId);

  if (source.type === 'upload') {
    form.append('comparison_fit_file', source.file);
  } else if (source.type === 'myfile') {
    form.append('comparison_file_id', source.fileId);
  } else if (source.type === 'community') {
    form.append('comparison_shared_id', source.sharedId);
  }

  const response = await api.post('/compare', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

/**
 * Get the user's saved FIT files for use as comparison workout B.
 */
export const getMyBikeFitFiles = async () => {
  const response = await api.get('/auth/my-files/fit');
  return response.data;
};

/**
 * List community bike workouts for comparison.
 */
export const listCommunityBikeWorkouts = async (params = {}) => {
  const response = await api.get('/community/workouts', { params });
  return response.data;
};
